import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";

import "./Navbarhorizontal.css";

function Navbarhorizontal({ onClose }) {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const first_name = localStorage.getItem("first_name")
  // const firstname= localStorage.getItem("first_name")

  const [showModal, setShowModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPasswords, setShowPasswords] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("is_admin");
    localStorage.removeItem("username");
    localStorage.removeItem("first_name");
    navigate("/login");
  };

  return (
    <>
      <nav className="main-nav">
  <div className="main-nav-logo"></div>
  <div className="navbar_loginSuccess">
    {username && (
      <div className="main-nav-item dropdown">
        <span
          className="username-dropdown-trigger"
          onClick={() => setShowDropdown((prev) => !prev)}
        >
          {first_name} <i className="fa fa-caret-down"></i>
        </span>

        {showDropdown && (
          <div className="dropdown-content">
            
            <p
              onClick={() => {
                setShowModal(true);
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
                setError("");
                setShowDropdown(false);
              }}
            >
              Changer mot de passe
            </p>
            <p onClick={handleLogout}>Déconnexion</p>
          </div>
        )}
      </div>
    )}
  </div>
</nav>


      {showModal && (
        <ChangePasswordModal
          currentPassword={currentPassword}
          newPassword={newPassword}
          confirmPassword={confirmPassword}
          setCurrentPassword={setCurrentPassword}
          setNewPassword={setNewPassword}
          setConfirmPassword={setConfirmPassword}
          showPasswords={showPasswords}
          setShowPasswords={setShowPasswords}
          error={error}
          setError={setError}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
}

export default Navbarhorizontal;
